import {BreadcrumbStep} from '@/app/lib/structuredData'
import {getSpecimenGuideContent} from '@/content/specimenGuide'
import type {TFunction} from '@/i18n'

import {Locale} from '../constants'
import {routeTo} from '../router'
import {specimenGuideData} from './constants'
import {SpecimenGuideSector} from './types'

const {classes, sectors} = specimenGuideData()

export const getPopularSectorsByIds = (ids: string[]): SpecimenGuideSector[] => {
  const popularSectors = ids.map((id) => sectors[id] ?? null)

  return popularSectors.filter((item) => item !== null)
}

const getSpecimenGuideClassPaths = () =>
  Object.values(classes).map(({id}) => ({
    locale: Locale.en,
    params: {id},
  }))

const getSpecimenGuideSectorPaths = () =>
  Object.values(sectors).map(({slug}) => ({
    locale: Locale.en,
    params: {sector: slug},
  }))

const specimenGuideClassPaths = getSpecimenGuideClassPaths().map((obj) =>
  routeTo.specimenGuide.class(obj.params.id),
)

const specimenGuideSectorPaths = getSpecimenGuideSectorPaths().map((obj) =>
  routeTo.specimenGuide.sector(obj.params.sector),
)

export const specimenGuidePaths = [
  routeTo.specimenGuide.home(),
  ...specimenGuideClassPaths,
  ...specimenGuideSectorPaths,
]

/*
 * The root step is named after the index's own h1. A `BreadcrumbList` item names the page it points
 * at, and the back-link this replaces read "Back to selection" - what the link does to you, not
 * what the page is called.
 */
export const getSpecimenGuideTrail = (t: TFunction, leaf: BreadcrumbStep): BreadcrumbStep[] => [
  {name: t(getSpecimenGuideContent().hero.title), path: routeTo.specimenGuide.home()},
  leaf,
]
